// src/Result.js
import React, { useState, useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import axios from 'axios'
import './Results.css'
import Stars from './Results/Stars'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import startMessages from './Results/startmessages.json'
import TSPopup from './TableSearch/TsPopup'
import AdminDrawer from './Results/AdminDrawer'
import TSDrawer from './TableSearch/TsDrawer'
import SettingsDrawer from './Results/SettingsDrawer'
import HeaderButtons from './Results/HeaderButtons'
import ResultcardsContainer from './Results/ResultcardsContainer'
import ResultsSearchBar from './Results/ResultsSeachBar'
import { getEnv } from './config/env'

const Result = () => {
  const { state } = useLocation()
  const [query, setQuery] = useState('')
  const [id, setId] = useState(state?.id)
  const [index, setIndex] = useState(state?.index)
  const [searchContext, setSearchContext] = useState(state?.searchContext || 'document')
  const [model, setModel] = useState('gpt-4o')
  const [showModel, setShowModel] = useState(true)
  const [messages, setMessages] = useState(state?.messages || [])
  const [isLoading, setIsLoading] = useState(false)
  const [textColor, setTextColor] = useState('#000000')
  const [selectedFont, setSelectedFont] = useState('Arial, sans-serif')
  const [initialSearchPerformed, setInitialSearchPerformed] = useState(false)
  const [userId, setUserId] = useState(state?.userId)
  const [userMail, setUserMail] = useState(state?.userMail)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [isSearchOpen, setIsSearchOpen] = useState(false)
  const [system_message_temp, setSystemMessageTemp] = useState('')
  const [system_message, setSystemMessage] = useState(state?.system_message || '')
  const [selected_session, setSelectedSession] = useState('K1')
  const [sessions, setSessions] = useState([])
  const [streamCompleted, setStreamCompleted] = useState(true)
  const [sessionDropdownDisabled, setSessionDropdownDisabled] = useState(false)
  const [showSystemMessage, setShowSystemMessage] = useState(state?.showSystemMessage)
  const [showSearchContextOptions, setShowSearchContextOptions] = useState(state?.showSearchContextOptions)
  const [language, setLanguage] = useState(state?.language || 'None')
  const [graph, setGraph] = useState(state?.graph)
  const [ErrorFlag, setErrorFlag] = useState('')
  const [startMessage, setStartMessage] = useState('')
  const [tableSearchMessage, setTableSearchMessage] = useState('')
  const [tableSearchResults, setTableSearchResults] = useState([])
  const [searchActivated, setSearchActivated] = useState(true)
  const [littleLoading, setLittleLoading] = useState(false)
  const [tsIsOpen, setTsOpen] = useState(false)
  const [selectedTable, setSelectedTable] = useState('')
  const [unsaved, setUnsaved] = useState(false)
  const [temperature, setTemperature] = useState(0.7)
  const [isAdmin, setIsAdmin] = useState(false)
  const [adminDrawerOpen, setAdminDrawerOpen] = useState(false)
  const [cancelToken, setCancelToken] = useState(null)

  const admins = ['gustav.wessberg@stratsys.se']
  const [adminConfig, setAdminConfig] = useState({
    admins: admins,
    allowedSearchContext: ['document', 'sql', 'translate', 'web'],
    defaultSearchContext: 'document',
    allowedLLMs: ['gpt-4o', 'gpt-4o-mini'],
    showTemperature: true,
    allowedChangingSM: true,
    defaultTemperature: 0.7,
    systemMessage: '',
    startMessage: ''
  })

  useEffect(() => {
    console.log('State')
    console.log(state)
    if (!state) {
      navigate('/', { replace: true })
      console.log('No state')
    }
    setStartMessage(startMessages[state?.index])
    console.log(userMail)
    console.log(admins)

    async function fetchAdmin() {
      const response = await window.PDR.api.post(`${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/getAdmin`, {
        index: index
      })
      console.log(response)
      setAdminConfig(response.adminConfig)
      //Här uppdateras allt från admin config
      setSearchContext(response.adminConfig.defaultSearchContext)
      if (response.adminConfig.defaultSearchContext === 'web' || response.adminConfig.defaultSearchContext === 'sql') {
        setShowModel(false)
        setModel('gpt-4o')
      } else {
        setModel('gpt-4o-mini')
      }
      setTemperature(response.adminConfig.defaultTemperature)
      // Systemmessage?
      setStartMessage(response.adminConfig.startMessage)
      if (response.adminConfig.admins.some((admin) => admin.toLowerCase() === userMail.toLowerCase())) {
        console.log('Admin')
        setIsAdmin(true)
      }
    }
    fetchAdmin()
  }, [])

  useEffect(() => {
    // Scroll to the bottom when new cards are added
    document.title = 'Stratsys AI'
    const resultCardsContainer = document.getElementById('result-cards-container')
    if (resultCardsContainer) {
      resultCardsContainer.scrollTop = resultCardsContainer.scrollHeight
    }
  }, [messages])

  const handleTextAreaInput = (event) => {
    setQuery(event.target.value)
  }
  const handleTextAreaKeyPress = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault() // Prevent the default behavior of the "Enter" key
      event.target.blur() // Lock the textarea by removing focus
      handleSearch() // Call the handleSearch function
    }
  }
  const [deleteDisabled, setDeleteDisabled] = useState(false)

  const openAdminDrawer = () => {
    if (adminDrawerOpen) {
      console.log('Admin Drawer Closed')
      setAdminDrawerOpen(false)
    } else {
      setAdminDrawerOpen(true)
      console.log('Admin Drawer Open')
    }
  }
  const openDrawer = () => {
    if (!isDrawerOpen) {
      handleGetSystemMessage()
      // setSystemMessageTemp(system_message);
      setIsDrawerOpen(true)
      getSessions()
    } else {
      setIsDrawerOpen(false)
    }
  }

  const openSearch = () => {
    if (!isSearchOpen) {
      setIsSearchOpen(true)
    } else {
      setIsSearchOpen(false)
    }
  }

  const closeSearch = () => {
    setIsSearchOpen(false)
  }

  const closeDrawer = () => {
    setIsDrawerOpen(false)
  }

  const closeAdminDrawer = () => {
    setAdminDrawerOpen(false)
  }

  const navigate = useNavigate()
  useEffect(() => {
    if (!state) {
      navigate('/', { replace: true })
    }
  }, [state, navigate])

  const handleStatisticsClick = (query, answer, results, summary) => {
    // Navigate to the Statistics view with query and answer as parameters
    navigate(`/statistics`, {
      state: {
        query,
        answer,
        results,
        summary,
        messages,
        id,
        userId,
        userMail,
        index,
        searchContext,
        language,
        showSearchContextOptions,
        showSystemMessage,
        graph
      }
    })
  }

  function parseAndConcatenateData(data) {
    // Match all JSON objects in the string, accounting for nested braces
    const jsonObjects = []
    let openBraces = 0
    let currentJson = ''

    for (let char of data) {
      if (char === '{') {
        openBraces += 1
      }
      if (char === '}') {
        openBraces -= 1
      }
      currentJson += char
      if (openBraces === 0 && currentJson.trim() !== '') {
        jsonObjects.push(currentJson.trim())
        currentJson = ''
      }
    }

    if (jsonObjects.length > 0) {
      // Add a comma between JSON objects to create a valid JSON array
      const jsonArrayStr = `[${jsonObjects.join(',')}]`

      console.log(jsonArrayStr)

      try {
        const parsedArray = JSON.parse(jsonArrayStr)
        const concatenatedData = parsedArray.map((obj) => obj.data).join('')
        return { answer: concatenatedData, id: parsedArray[0].id }
      } catch (error) {
        console.error('Error parsing data:', error.message)
        return { answer: 'Error', id: '' }
      }
    }

    return { answer: '', id: '' }
  }

  const getSessions = async () => {
    try {
      //const user_info = await getUserInfo()
      const response = await window.PDR.api.post(`${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/get_sessions`, {
        userId: userId
      })
      console.log('Sessions:')
      console.log(response)
      const sortedSessions = response.sessions.sort((a, b) => b.timestamp - a.timestamp)
      setSessions(sortedSessions)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const handleTemp = (event) => {
    console.log(event.target.value)
    setTemperature(event.target.value)
  }

  const handleSearch = async () => {
    if (query === '') {
      return
    }

    setErrorFlag('')
    let receivedId = ''
    let receivedAnswer = ''
    setStreamCompleted(false)
    setSessionDropdownDisabled(true)
    if (messages.length === 0) {
      setSessions((prevSessions) => [
        { id: 'Pending', summary: query, timestamp: Math.floor(Date.now() / 1000) },
        ...prevSessions
      ])
    }
    setSelectedSession(query)

    if (!query) {
      // Don't perform the search if the query is empty
      return
    }

    setIsLoading(true)
    try {
      let newMessage = {
        query,
        answer: '',
        results: [],
        summary: ''
      }

      setMessages((prevMessages) => [...prevMessages, newMessage])
      //const user_info = await getUserInfo()

      console.log('Innan streming')

      var cancelToken = window.PDR.api.createCancellationToken()
      setCancelToken(cancelToken)

      const response2 = await window.PDR.api.post(
        `${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/chat`,
        {
          query: query,
          id: id,
          index: index,
          model: model,
          userId: userId,
          userMail: userMail,
          searchContext: searchContext,
          language: language,
          temperature: temperature
        },
        {
          cancellationToken: cancelToken,
          options: {
            stream: (partialResult) => {
              console.log('STREAMING')
              console.log(partialResult)
              //const chunkString = new TextDecoder().decode(partialResult)
              try {
                receivedAnswer = parseAndConcatenateData(partialResult).answer
                if (receivedId === '') {
                  receivedId = parseAndConcatenateData(partialResult).id
                }
                setId(receivedId)

                console.log(receivedAnswer)
                console.log(receivedId)
                console.log(id)

                if (receivedAnswer != null) {
                  // Update the state to add a new message to the chat
                  setMessages((prevMessages) => {
                    // Make a copy of the previous messages array
                    const newMessages = [...prevMessages]

                    // Check if there are existing messages
                    if (newMessages.length > 0) {
                      // Update only the 'answer' property of the last message
                      newMessages[newMessages.length - 1] = {
                        ...newMessages[newMessages.length - 1], // copy existing properties
                        answer: newMessages[newMessages.length - 1].answer + receivedAnswer,
                        summary: '',
                        results: ''
                      }
                      return newMessages
                    } else {
                      newMessages.push({
                        query,
                        answer: receivedAnswer
                      })
                    }
                    return newMessages
                  })
                }
              } catch (error) {
                console.error('Error parsing data:', error)
                setErrorFlag('ERROR: Please refresh the page.')
              }
            }
          }
        }
      )

      // Read chunks of data as they arrive

      try {
        setQuery('')
        //const user_info = await getUserInfo()

        console.log('ErrorFlag: ' + ErrorFlag)
        console.log('ReceivedId: ' + receivedId)
        const response = await window.PDR.api.post(`${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/conversation`, {
          id: receivedId || id,
          model: 'gpt-4o',
          index: index,
          userMail: userMail,
          userId: userId
        })

        const apiResponse = response

        setMessages([])
        for (let i = 0; i < apiResponse.messages.length; i++) {
          let imageUrl = ''
          console.log('URL:')
          console.log(apiResponse.messages[i])
          if (apiResponse.messages[i].imageUrl) {
            if (apiResponse.messages[i].imageUrl !== 'deleted') {
              try {
                const response = await axios({
                  method: 'post',
                  url: `${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/graph`,
                  data: { session_id: receivedId, nr: i, userId: userId },
                  responseType: 'blob' // Set the response type to 'blob'
                })
                imageUrl = URL.createObjectURL(response)
                console.log(imageUrl)
              } catch (error) {
                console.error('Error fetching the graph:', error)
                setErrorFlag('ERROR: Issue with fetching the graph. Please refresh the page.')
              }
            }
          }

          // create an object with the properties from the api response
          let obj = {
            answer: apiResponse.messages[i].answer,
            query: apiResponse.messages[i].query,
            results: apiResponse.messages[i].results,
            summary: apiResponse.messages[i].summary,
            imageUrl: imageUrl,
            graph: apiResponse.messages[i].graph,
            graph_config: apiResponse.messages[i].graph_config || {}
          }
          // update the messages array with the object
          setMessages((prevMessages) => [...prevMessages, obj])
          console.log(obj.answer)
        }

        setIsLoading(false)
        setStreamCompleted(true)
        setSessionDropdownDisabled(false)
        await getSessions()
      } catch (error) {
        console.error('Error fetching data 2:', error)
        setErrorFlag('ERROR2: Please refresh the page.')
      }
    } catch (error) {
      if (error && error.message && error.message.includes('[PDR.api] Request cancelled')) {
        console.log('Request was canceled, ignoring this error.')
        // Optionally, perform any specific tasks that are needed when the request is canceled
      } else {
        // Handle other errors
        console.error('Error fetching data:', error)
      }
      setIsLoading(false)
    }
  }

  const handleTableSearch = async () => {
    if (tableSearchMessage !== '') {
      setSearchActivated(false)
      const response = await window.PDR.api.post(`${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/tablesearch`, {
        query: tableSearchMessage
      })
      console.log(response[0].context.slice(0, 20))
      setTableSearchMessage('')
      setTableSearchResults(response)
      setSearchActivated(true)
    }
  }

  const handleDelete = async (session_id) => {
    setDeleteDisabled(true)
    setMessages([])
    setQuery('')
    setId('')
    //const user_info = await getUserInfo()
    const response = await window.PDR.api.post(`${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/delete`, {
      id: session_id,
      userId: userId
    })
    setSessions((prevSessions) => prevSessions.filter((session) => session.id !== session_id))
    setSessionDropdownDisabled(false)
    setDeleteDisabled(false)
  }

  const handleClear = async (event) => {
    if (cancelToken) {
      await cancelToken.cancel()
      console.log('Cancelled')
      setCancelToken(null)
    }
    setStreamCompleted(true)

    setQuery('')
    setId('')
    handleGetSystemMessage({ id_arg: '' })
    setMessages([])
    setStartMessage(adminConfig.startMessage)
    setSessionDropdownDisabled(false)
    setSearchContext(adminConfig.defaultSearchContext)
    setErrorFlag('')

    if (adminConfig.defaultSearchContext === 'translate' || adminConfig.defaultSearchContext === 'document') {
      setShowModel(true)
    } else {
      setShowModel(false)
      console.log('Stänger')
      setModel('gpt-4o')
    }
  }

  const handleSessionChange = async (session_id) => {
    setErrorFlag('')
    setSessionDropdownDisabled(true)
    setSelectedSession(session_id)
    setId(session_id)
    setMessages([])
    try {
      //const user_info = await getUserInfo()
      const response = await window.PDR.api.post(`${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/conversation`, {
        id: session_id,
        index: index,
        userMail: userMail,
        userId: userId
      })

      const apiResponse = response
      setIndex(apiResponse.index)

      setTemperature(apiResponse.temperature)
      setStartMessage(startMessages[apiResponse.index])
      const system_message_response = await window.PDR.api.post(
        `${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/get_system_message`,
        {
          id: session_id,
          userId: userId,
          index: apiResponse.index
        }
      )
      setSystemMessage(system_message_response.data)
      setSystemMessageTemp(system_message_response.data)

      if (system_message_response.searchContext === null) {
        handleSearchContext({ target: { value: 'document' } })
      } else {
        handleSearchContext({ target: { value: system_message_response.searchContext } })
      }
      handleModel({ target: { value: apiResponse.model } })

      for (let i = 0; i < apiResponse.messages.length; i++) {
        let imageUrl = ''
        if (apiResponse.messages[i].imageUrl) {
          try {
            const response = await axios({
              method: 'post',
              url: `${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/graph`,
              data: { session_id: session_id, nr: i, userId: userId },
              responseType: 'blob' // Set the response type to 'blob'
            })
            imageUrl = URL.createObjectURL(response)
            console.log(imageUrl)
          } catch (error) {
            console.error('Error fetching the graph:', error)
          }
        }
        console.log(apiResponse.messages[i].graph)
        console.log('graph_config')
        console.log(apiResponse.messages[i].graph_config)
        setGraph(apiResponse.messages[i].graph)
        // create an object with the properties from the api response
        let obj = {
          answer: apiResponse.messages[i].answer,
          query: apiResponse.messages[i].query,
          results: apiResponse.messages[i].results,
          summary: apiResponse.messages[i].summary,
          imageUrl: imageUrl,
          graph: apiResponse.messages[i].graph,
          graph_config: apiResponse.messages[i].graph_config
        }
        // update the messages array with the object
        setMessages((prevMessages) => [...prevMessages, obj])
      }
      setSessionDropdownDisabled(false)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const handleSearchContext = async (event) => {
    console.log(event.target.value)
    setSearchContext(event.target.value)

    if (event.target.value === 'translate' || event.target.value === 'document') {
      setShowModel(true)
    } else {
      setShowModel(false)
      console.log('Stänger')
      setModel('gpt-4o')
    }
  }

  const handleGetSystemMessage = async (id_arg) => {
    const response = await window.PDR.api.post(`${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/get_system_message`, {
      id: id_arg || id,
      userId: userId,
      index: index
    })
    setSystemMessage(response.data)
    setSystemMessageTemp(response.data)
  }

  const handleSystemMessageChange = (event) => {
    setUnsaved(true)
    setSystemMessageTemp(event.target.value)
  }
  const handleTableSearchInput = async (event) => {
    setTableSearchMessage(event.target.value)
  }

  const handleSaveSystemMessage = async (event) => {
    setUnsaved(false)
    const response = await window.PDR.api.post(`${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/set_system_message`, {
      id: id,
      message: system_message_temp,
      userId: userId,
      index: index,
      searchContext: searchContext
    })
    setId(response.id)
    setSystemMessage(system_message_temp)
  }

  const handleSaveSystemMessageReset = async (event) => {
    const response = await window.PDR.api.post(
      `${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/reset_system_message`,
      {
        id: id,
        userId: userId,
        index: index
      }
    )
    setSystemMessage(response.data)
    setSystemMessageTemp(response.data)
  }
  //test
  const handleModel = (event) => {
    console.log(event.target.value)
    setModel(event.target.value)
  }

  const handleAnalyze = async () => {
    navigate(`/analyze`)
  }

  const togglePopup = () => {
    setTsOpen(!tsIsOpen)
  }

  const handleTSPopup = (title, context) => {
    setSelectedTable({ title, context })
    togglePopup()
  }

  return (
    <div className="result-container">
      <TSPopup isOpen={tsIsOpen} onClose={togglePopup} tableTitle={selectedTable}>
        {' '}
      </TSPopup>
      <div className="header">
        {/* Icon and title in the upper right corner */}
        <img
          className="stratsys-search-logo"
          src="https://frontend-packages.svc.stratsys.com/logos/icon-dark.svg"
          alt="Stratsys Icon"
        />
        <HeaderButtons
          showSearchContextOptions={showSearchContextOptions}
          openSearch={openSearch}
          openAdminDrawer={openAdminDrawer}
          openDrawer={openDrawer}
          isAdmin={isAdmin}
          userId={userId}
          userMail={userMail}
          adminConfig={adminConfig}></HeaderButtons>
      </div>
      <div>
        <TSDrawer
          isSearchOpen={isSearchOpen}
          closeSearch={closeSearch}
          searchActivated={searchActivated}
          tableSearchMessage={tableSearchMessage}
          handleTableSearchInput={handleTableSearchInput}
          handleTableSearch={handleTableSearch}
          tableSearchResults={tableSearchResults}
          handleTSPopup={handleTSPopup}></TSDrawer>

        <AdminDrawer
          isDrawerOpen={adminDrawerOpen}
          closeDrawerFunc={closeAdminDrawer}
          adminConfig={adminConfig}
          setAdminConfig={setAdminConfig}
          userMail={userMail}
          index={index}></AdminDrawer>

        <SettingsDrawer
          isDrawerOpen={isDrawerOpen}
          closeDrawer={closeDrawer}
          showSearchContextOptions={showSearchContextOptions}
          searchContext={searchContext}
          handleSearchContext={handleSearchContext}
          model={model}
          handleModel={handleModel}
          showModel={showModel}
          adminConfig={adminConfig}
          handleAnalyze={handleAnalyze}
          system_message_temp={system_message_temp}
          handleSystemMessageChange={handleSystemMessageChange}
          handleSaveSystemMessage={handleSaveSystemMessage}
          handleSaveSystemMessageReset={handleSaveSystemMessageReset}
          unsaved={unsaved}
          handleTemp={handleTemp}
          showSystemMessage={showSystemMessage}
          showTemperature={adminConfig.showTemperature}
          sessions={sessions}
          id={id}
          userMail={userMail}
          index={index}
          handleDelete={handleDelete}
          handleSessionChange={handleSessionChange}
          sessionDropdownDisabled={sessionDropdownDisabled}
          deleteDisabled={deleteDisabled}
          temperature={temperature}></SettingsDrawer>
      </div>

      <div>{ErrorFlag && <p className="ErrorText">{ErrorFlag}</p>}</div>
      {/* Display results cards */}

      <ResultcardsContainer
        messages={messages}
        isLoading={isLoading}
        streamCompleted={streamCompleted}
        id={id}
        userId={userId}
        userMail={userMail}
        searchContext={searchContext}
        handleStatisticsClick={handleStatisticsClick}
        adminConfig={adminConfig}
        index_dep={index}></ResultcardsContainer>

      <ResultsSearchBar
        query={query}
        handleTextAreaInput={handleTextAreaInput}
        handleTextAreaKeyPress={handleTextAreaKeyPress}
        handleSearch={handleSearch}
        handleClear={handleClear}
        sessionDropdownDisabled={sessionDropdownDisabled}></ResultsSearchBar>
    </div>
  )
}

export default Result
